import { Children, useEffect, useRef, useState } from "react";
import specialStyles from "./SpecialStyles.module.css";
import {
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  DropdownItem,
} from "reactstrap";

const CustomizableSpecialDropdown = ({
  toggler,
  className,
  style,
  menuItems,
  renderItem,
  children,
}) => {
  const [isOpen, setisOpen] = useState(false);

  return (
    <Dropdown
      className="bg-transparent"
      isOpen={isOpen}
      toggle={() => setisOpen((prev) => !prev)}
    >
      <DropdownToggle className="bg-transparent border-0 mb-4">
        {toggler}
      </DropdownToggle>
      <DropdownMenu
        style={{ minWidth: "300px", width: "230px" }}
        className="bg-transparent box-shadow-none border-none p-2"
      >
        <div className={specialStyles?.special_dropdown_menu_indicator}></div>
        <div className={specialStyles?.special_dropdown_menu}>
          <div className={specialStyles?.special_dropdown_items}>
            {menuItems && renderItem
              ? menuItems?.map((item, index) => (
                  <>
                    <div className="px-2 "> {renderItem(item, index)}</div>
                  </>
                ))
              : Children.map(children, (child, index) => (
                  <div className="px-2" key={`item-${index}`}>
                    {child}
                  </div>
                ))}
          </div>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default CustomizableSpecialDropdown;
